import React from 'react';

import { IconVerificacao } from '../../atoms/IconVerificacao';
import { Container, Text } from './styles';

interface PasswordData {
  name: string;
}

export const InfoPassword = ({ name }: PasswordData): JSX.Element => {
  return (
    <Container>
      <IconVerificacao />
      <Text> {name} </Text>
    </Container>
  );
};
